import BaseRepository from "./BaseRepository";
import ProjectModel from "../models/project";

export default class ProjectRepository extends BaseRepository {
    async get() {
        let uri = '/projects/';

        let response = await this._requestWithTimeoutAsync('GET', uri);

        if (response === undefined) {
            return [];
        }

        console.log('Status: ', response.status);

        let json = await response.json();
        let projects = this.__mapJsonToProjectModels(json);

        console.log('Projects: ', projects);

        return projects;
    }

    __mapJsonToProjectModels(json) {
        let projects = [];

        json.forEach((raw) => {
            projects.push(new ProjectModel(raw.id, raw.name, raw.number));
        });

        return projects;
    }
}


// WEBPACK FOOTER //
// ./src/data/ProjectRepository.js